"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _trayMenu = require("@ux/tray-menu");
var _enums = require("../enums");
var _eid = _interopRequireDefault(require("../eid"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render signIn section.
 *
 * @type {React.FunctionComponent}
 * @param {Object} props Props
 * @returns {React.ReactElement} SignIn button element
 * @api public
 */
function SignIn(props) {
  const eids = (0, _react.useMemo)(() => {
    return {
      login: (0, _eid.default)({
        key: _enums.golf.login,
        manifest: props.manifest
      })
    };
  }, [props.manifest]);
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: props.market,
    messages: props.messages
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sign-in"
  }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.registeredUser
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.signInAccountMessage
  })), /*#__PURE__*/_react.default.createElement(_link.default, {
    urlArgs: props.urlArgs,
    href: props.loginLink,
    "data-eid": eids.login,
    "data-version": "2400",
    className: "ux-button ux-button-primary ux-button-small"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.login
  }))));
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
SignIn.propTypes = {
  loginLink: _propTypes.default.string.isRequired,
  privateLabelId: _propTypes.default.number,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  manifest: _propTypes.default.string,
  urlArgs: _propTypes.default.object
};
var _default = SignIn;
exports.default = _default;